import { $ } from 'donot';
import { createApp, onMounted, ref } from 'vue';
import YearrangeInput from './yearrange-input.vue';

export function searchform(el) {
    createApp({
        components : { YearrangeInput },

        setup() {
            // State
            const hasSearchQuery = ref(false);
            // If there is a search/filter, open up the filter menu to indicate that things are active
            const showFilter = ref(false);
            let searchquery;

            function checkSearchQuery() {
                hasSearchQuery.value = searchquery.value.length > 0;
            }

            function clearSearch() {
                searchquery.value = '';
                checkSearchQuery();
            }

            function disableEmptyFields(e) {
                // The search form is all GET-based, which makes for nicely
                // shareable (but very ugly) URLS.
                //
                // To prevent empty values from ending up in the URL before the
                // search form is submitted we check for all form fields in the
                // search form and disable them if they have no value to prevent
                // them from getting into the GET query.
                //
                // Note that this is progressive enhancement: if the user
                // has Javascript disabled things will still work (with ugly URLS)
                for (const element of el.querySelectorAll("[id]")) {
                    // If there is no value, disable the form element
                    element.disabled = !element.value;
                }
            }

            function handleSearch(e) {
                disableEmptyFields();
            }

            function toggleFilter() {
                showFilter.value = !showFilter.value;
            }

            onMounted(() => {
                searchquery = $('#q');
                showFilter.value = !!$('meta[name="has-filter"]');
                checkSearchQuery();
            });

            return {
                checkSearchQuery, clearSearch, handleSearch, hasSearchQuery, showFilter, toggleFilter
            }
        }
    }).mount(el);
}